"use client";

import type { NextPage } from "next";
import { LoginPageLayout } from "src/components/layout/LoginPageLayout";
import { AlreadyLoggedIn } from "src/components/login/AlreadyLoggedIn";
import { OrgSignupForm } from "src/partials/login/OrgSignupForm";
import { useAuth } from "src/state/AuthContext";
import { useTranslations } from "src/state/TranslationsContext";

const LoginBody = () => {
  const { user, isAuthenticated } = useAuth();
  const { t } = useTranslations();

  if (isAuthenticated && user) {
    return <AlreadyLoggedIn user={user} />;
  }

  return (
    <>
      <h4 className="mb-3">{t("client.signup.welcome")}</h4>
      <OrgSignupForm />
    </>
  );
};

export const SignUpPage: NextPage = () => {
  const { t } = useTranslations();
  const { isAuthenticated } = useAuth();

  return (
    <LoginPageLayout
      title={t("client.signup.title")}
      isAuthenticated={isAuthenticated}
      unauthenticatedMessage={t("client.signup.sidebar_welcome")}
    >
      <LoginBody />
    </LoginPageLayout>
  );
};
